import React, { useContext } from "react";

import { putpost } from "services/http";

import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

import { PermissionContext, RolePermissions } from "appContext";
import { constants, endpoint, pages } from "../../common/constant";
import { getPaginatedData } from "../../common/utils/methods/commonMethods/paginationMethod";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";

import moment from "moment";

import ManageEmployees from "./ManageEmployees";
import { PermisionDenied } from "../../common/commonComponents";

const pageSize = 10;
let page = 0;
let isNextCallPossible = true;

const itemToBeRenderFromMaster = ["designationId", "departmentId"];
const propertyList = ["", "", "label", "label", "", ""];

const altList = [null, null, "designation", "department", null, null];

const ProfileSearchPage = () => {
  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(
    permissions,
    pages["createUserProfile"]["id"]
  );

  // const downloadFile = (url) => {
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", `search-result.xlsx`);
  //   document.body.appendChild(link);
  //   link.click();
  //   link.parentNode.removeChild(link);
  // };

  // const fetchNext = async () => {
  //   setIsFetching(true);
  //   page = page + 1;
  //   const templateData = await fetchAllPostPromisedData(
  //     `${endpoint.searchProfile}/${page}`,
  //     savedSearchParams
  //   );
  //   if (templateData?.code === 200 && templateData?.data?.length > 0) {
  //     const updatedData = [...serverData, ...templateData.data];
  //     setServerData(updatedData);
  //     getPaginatedData(
  //       updatedData,
  //       pageSize,
  //       pagination,
  //       setpagination,
  //       setIsFetching,
  //       setTableData
  //     );
  //     isNextCallPossible = templateData?.data?.length == 50 ? true : false;
  //   } else {
  //     isNextCallPossible = false;
  //     setIsFetching(false);
  //   }
  // };

  // const resetPassword = () => {
  //   if (!ticketDetails.ticketId) {
  //     failureToast("Please enter ticket ID");
  //     return;
  //   }

  //   if (
  //     ticketDetails.ticketId &&
  //     ticketDetails.ticketId.toString().length < 5
  //   ) {
  //     failureToast("Please enter valid ticket ID");
  //     return;
  //   }

  //   if (!ticketDetails.ticketDate) {
  //     failureToast("Please select ticket date");
  //     return;
  //   }

  //   setReseting(true);

  //   putpost(
  //     endpoint.requestResetPassword,
  //     (data) => {
  //       if (data?.code == 200) {
  //         setResetDialogOpen(false);
  //         setConfirmationDialog(true);
  //         setUserIdToReset(null);
  //       }
  //     },
  //     (data) => {
  //       failureToast(data["message"]);
  //       setReseting(false);
  //       // setResetDialogOpen(false)
  //     },
  //     {
  //       ...ticketDetails,
  //       ticketDate: moment(ticketDetails.ticketDate).format("MM.DD.YYYY"),
  //       userId: userIdToReset,
  //       clientId: "PHX",
  //       ticketDescription: "Reset password-Support",
  //     },
  //     "post"
  //   );
  // };

  // const resetPasswordDialog = () => {
  //   setTicketDetails({
  //     ticketId: "",
  //     ticketDate: null,
  //   });
  //   setReseting(false);
  // };

  return userPermissions.length ? (
    <ManageEmployees userPermissions={userPermissions} />
  ) : (
    <PermisionDenied />
  );
};

export default ProfileSearchPage;
